export default __webpack_public_path__ + "static/media/activity-fluid-icon.e6c3d08e.svg";